<template>
    <b-overlay :show="loading" rounded="sm">
    <div class="container-scroller customer-portal-navbar">
        <!-- Top Nav -->
        <div class="navbar portal-navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row"
            :style="customColor">
            <b-col cols="12" md="6" sm="6" class="d-flex flex-column flex-md-row">
                <b-row class="ps-4 pt-1 col-12">
                    <b-col class="text-center customer-portal-logo text-md-start" xl="3" lg="4" cols="6"><img
                            :src="imageUrl" height="150px" width="150px" alt="logo" /></b-col>
                    <b-col class="text-center text-md-start mt-2 portal-description" xl="9" lg="8" cols="6"><span><strong>
                                <div>
                                    <span v-if="companyAddress.name">{{
                                        companyAddress.name
                                    }}</span><br v-if="companyAddress.address1" />
                                    <span v-if="companyAddress.address1">{{
                                        companyAddress.address1
                                    }}</span><br v-if="companyAddress.address2" />
                                    <span v-if="companyAddress.address2">{{
                                        companyAddress.address2
                                    }}</span><br v-if="companyAddress.city" />
                                    <span v-if="companyAddress.city">{{
                                        companyAddress.city
                                    }}</span><br v-if="companyAddress.state" />
                                    <span v-if="companyAddress.state">{{
                                        companyAddress.state
                                    }}</span><br v-if="companyAddress.country &&
        companyAddress.country.country_name
        " />
                                    <span v-if="companyAddress.country &&
                                        companyAddress.country.country_name
                                        ">{{
        companyAddress.country.country_name
    }}</span>
                                </div>
                            </strong></span></b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="6" sm="6" class="align-self-start">
                <div class="navbar-menu-wrapper d-flex align-items-stretch justify-content-end">
                    <!-- <b-navbar-nav class="ml-auto"> -->
                    <b-button variant="plain" class="my-3" @click="getSupport" target="_blank" v-b-tooltip.hover
                        title="Press for Support">
                        <b-icon icon="question-circle-fill" aria-label="Help"></b-icon>
                    </b-button>
                    <ul class="navbar-nav navbar-nav-right">
                        <li class="d-flex me-3 align-items-center gap-2">
                            <b-dropdown variant="light" toggle-class="d-flex align-items-center gap-2"
                                menu-class="dropdown-menu flag-dropdown navbar-dropdown">
                                <template #button-content>
                                    <div>
                                        <span :class="selectedLanguage.flagClass"></span>
                                        <span>{{
                                            selectedLanguage.label
                                        }}</span>
                                    </div>
                                </template>
                                <b-dropdown-item v-for="language in languages" :key="language.id"
                                    @click="changeLanguage(language.id)">
                                    <i :class="language.flagClass"></i>
                                    {{ language.label }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </li>
                        <b-form-select v-model="customer_id" class="me-2 me-lg-5 form-control" :options="customers"
                            text-field="name" value-field="id"></b-form-select>
                        <li class="nav-item nav-profile dropdown">
                            <b-nav-dropdown :offset="10" id="profileDropdown" toggle-class="dropdown-toggle"
                                :style="customColor" menu-class="dropdown-menu navbar-dropdown">
                                <template #button-content>
                                    <div class="nav-profile-img">
                                        <img :src="profilePicture" alt="image" />
                                    </div>
                                    <div class="nav-profile-text">
                                        <em>{{ user.email }}</em>
                                    </div>
                                </template>
                                <b-dropdown-item to="/customer-portal/profile">
                                    <img src="@/assets/images/icon/profile.svg" class="menu-icon-bar" />
                                    <span>{{ $translate('profile') }}</span>
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item @click="logout()">
                                    <img src="@/assets/images/icon/logout.svg" class="menu-icon-bar" />
                                    <span>{{ $translate('logout') }}</span>
                                </b-dropdown-item>
                            </b-nav-dropdown>
                        </li>
                        <li class="nav-item dropdown notification">
                            <b-nav-dropdown id="notificationDropdown"
                                toggle-class="nav-link count-indicator dropdown-toggle"
                                menu-class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list">
                                <template #button-content>
                                    <div @click="updateCount()">
                                        <i class="mdi mdi-bell-outline"></i>
                                        <span class="count-symbol badge rounded-pill badge-notification bg-danger"
                                            v-if="!!notificationCount">{{
                                                notificationCount > 9
                                                ? '9+'
                                                : notificationCount
                                            }}</span>
                                    </div>
                                </template>
                                <h6 class="p-3 mb-0">
                                    {{ $translate('notifications') }}
                                </h6>
                                <h4 v-if="notifications && !notifications.length
                                    " class="text-center">
                                    {{ $translate('no_notifications') }}
                                </h4>
                                <b-dropdown-divider></b-dropdown-divider>
                                <div class="notification-body">
                                    <div v-for="(
                                            notification, index
                                        ) in visibleNotifications" :key="index">
                                        <!-- <b-dropdown-item  :to="`/customer-portal/view-service/${notification.data.id}`" -->
                                            <b-dropdown-item  @click="gotoDetails(notification.data.id)"  class="preview-item">
                                            <div class="preview-thumbnail">
                                                <img src="@/assets/images/icon/notification.svg" class="menu-icon-bar" />
                                            </div>
                                            <div
                                                class="preview-item-content d-flex align-items-start flex-column justify-content-center">
                                                <p class="text-gray ellipsis mb-0">
                                                    <strong>{{
                                                        notification.data.name
                                                    }}</strong>
                                                    {{
                                                        notification.data
                                                            .message
                                                    }}
                                                </p>
                                            </div>
                                        </b-dropdown-item>
                                        <b-dropdown-divider></b-dropdown-divider>
                                    </div>
                                </div>
                                <!-- <div> -->
                                <b-button class="w-100 m-0" v-if="notifications &&
                                    notifications.length > 3
                                    " @click="showAll = !showAll">
                                    {{
                                        showAll
                                        ? $translate('show_less')
                                        : $translate('show_all')
                                    }}
                                </b-button>
                                <!-- </div> -->
                            </b-nav-dropdown>
                        </li>
                    </ul>
                </div>
            </b-col>
        </div>
    </div>
    </b-overlay>
</template>
<script>
import logoImage from '@/assets/images/logo.png'
import popupMixins from '@/mixins/popupMixins'
import defaultProfile from '@/assets/images/faces/face1.jpg'
export default {
    name: 'customer-portal-navbar',
    mixins:[popupMixins],
    data: () => ({
        timer: null,
        loading: false,
        // sessionLogout: false,
        customer_id: null,
        showAll: false,
        languages: [
            { id: 'en', label: 'English', flagClass: 'flag-uk' },
            { id: 'es', label: 'Español', flagClass: 'flag-spain' },
        ],
        selectedLanguage: '',
    }),
    computed: {
        notifications() {
            return this.$store.state.notifications.items.data
        },

        visibleNotifications() {
            return this.showAll
                ? this.notifications
                : this.notifications && this.notifications.slice(0, 3)
        },
        notificationCount() {
            return this.$store.state.notifications.count
        },
        customColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + '!important',
                color: data.text_color + '!important',
            }
            return colors
        },
        user() {
            return this.$store.state.user || {}
        },
        toggleValue() {
            return this.$store.state.notifications.toggle
        },
        customers() {
            return this.$store.getters['userCustomers']
        },
        imageUrl() {
            let imageUrl
            const data = this.$store.state.company.settings || {}
            if (data && data.logo) {
                imageUrl = JSON.parse(data.logo).url
            } else {
                imageUrl = logoImage
            }
            return imageUrl
        },
        companyAddress() {
            const data = this.$store.state.company.settings || {}
            return data
        },
        profilePicture() {
            let image = this.$store.state.user?.profile_image
            return image ? image : defaultProfile
        },
    },
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler(val) {
                this.selectedLanguage = this.languages.find(
                    language => language.id === val
                )
            },
        },
        customer_id: function (val) {
            this.$store.commit(
                'customerPortal/SET_CUSTOMER',
                this.customers.find(x => x.id === val)
            )
        },
        toggleValue: {
            immediate: true,
            handler: async function (val) {
               /*  await this.$store.dispatch('notifications/fetchAll')
                if (val === 1) {
                    this.timer = setInterval(async () => {
                        await this.$store.dispatch('notifications/fetchAll')
                    }, 5000)
                } else {
                    clearInterval(this.timer)
                    this.timer = null
                } */
            },
        },
    },
    async mounted() {
        this.loading = true
        this.customer_id = this.customers[0].id
        const user_id = this.$store.state.user.id
        this.$store.dispatch('notifications/checkNotificationToggle', {
            user_id,
        })
        await this.$store.commit('customerPortal/SET_CUSTOMER', this.customers[0])
        await this.$store.dispatch('company/fetch')
        this.loading = false
    },
    methods: {
        getSupport() {
            window.open(
                'https://innovate10x.3cx.us/general',
                '_blank',
                'toolbar=no,scrollbars=yes,resizable=yes,top=500,left=500,width=300,height=500'
            )
        },
        changeLanguage(obj) {
            if (this.$i18n.locale !== obj) {
                this.$i18n.locale = obj
                localStorage.setItem('language', obj)
                this.$router.go()
            }
        },
        async updateCount() {
            await this.$store.dispatch('notifications/updateCount')
        },
        async logout() {
            this.loading = true
            const userData = this.$store.state.user
            await this.$store.dispatch('logout')
            // if (this.sessionLogout) {
            //     this.doToast(
            //         this.$translate('session_expired'),
            //         this.$translate(`relogin_message`),
            //         'danger'
            //     )
            // }
            this.loading = false
            if (userData.is_customer_user) {
                this.$router.push('/customer-login')
            } else {
                this.$router.push('/login')
            }
            return false
        },
        gotoDetails(id) {
            console.log('this is called!');
            // const currentPath = this.$route.fullPath;
            const targetPath = `/customer-portal/view-service/${id}`;
            this.$store.dispatch('customerPortal/fetchOrder', id)
            this.$store.dispatch('orders/fetchDrivers')
            this.$store.dispatch('company/fetch')
            this.$router.push(targetPath);
        
        }

    },
}
</script>

